import authDIModule from '@actr/stores/src/modules/account/auth';
import { AuthStore } from '@actr/stores/src/stores/stores/account/auth/auth';
import LocalAuthStore from 'Store/auth';

const localAuthDIModule = authDIModule.addOverrides(
  [AuthStore, LocalAuthStore]
);

export default localAuthDIModule;
